module.exports = __webpack_public_path__ + "static/thumbs-up2.5a010d0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/thumbs-up2.svg
// module id = 240
// module chunks = 35783957827783 172322841747965